import type { HelpFile } from '../../types/help'
import { ReviewInfoCardTestIds } from '../../../testids/ReviewInfoCardTestIds'

export const reviewInfoCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [ReviewInfoCardTestIds.reviewInfoCard]:
      'Reviewer decision metadata — who decided the request, when, and any comment left.',
    [ReviewInfoCardTestIds.cardTitleReviewInfo]: null,
    [ReviewInfoCardTestIds.linkReviewedBy]:
      'Open the detail page of the identity who reviewed this request.',
    [ReviewInfoCardTestIds.reviewInfoComment]:
      'Comment the reviewer left explaining the decision — always present for rejections.',
    [ReviewInfoCardTestIds.reviewInfoReviewedAt]:
      'When the reviewer recorded the decision.',
    [ReviewInfoCardTestIds.reviewInfoReviewer]: null,
  },
}
